import { Box, Container, Flex, Link, ScrollArea, Separator, Text, IconButton, DropdownMenu, Tooltip } from '@radix-ui/themes';
import { Rss, Github, Cloud } from 'lucide-react';

export default function SiteFooter() {
    return (
        <Container size="2">
            <Box mt="4">
                {/* <Box >
                    <ScrollArea size="1" scrollbars="horizontal">
                        <Flex gap="2" justify="center" align="center">
                            <Link size="2" weight="bold" href="/sponsor">赞助本站</Link>
                            <Separator orientation="vertical" />
                            <Link size="2" weight="bold" href="/release-notes">发布历史</Link>
                            <Separator orientation="vertical" />
                            <Link size="2" weight="bold" href="/about">关于本站</Link>
                            <Separator orientation="vertical" />
                            <Link size="2" weight="bold" href="/annual-reports">年度报告</Link>
                            <Separator orientation="vertical" />
                            <Link size="2" weight="bold" href="/similar-sites">同类网站</Link>
                        </Flex>
                    </ScrollArea>
                </Box> */}

                <Separator size="4" my="2" />

                <Box mt="4">
                    {/*
                    <Flex gap="2" justify="center" align="center">
                        <DropdownMenu.Root>
                            <DropdownMenu.Trigger>
                                <IconButton variant="soft">
                                    <Tooltip content="本站文章 RSS 订阅">
                                        <Rss width="14" height="14" />
                                    </Tooltip>
                                </IconButton>
                            </DropdownMenu.Trigger>
                            <DropdownMenu.Content>
                                <Link size="1" target="_blank" href="https://www.blogtalk.org/feed.xml"><DropdownMenu.Item>推荐文章 RSS 订阅</DropdownMenu.Item></Link>
                                <DropdownMenu.Separator />
                                <Link size="1" target="_blank" href="https://www.blogtalk.org/feed.xml?sort=latest"><DropdownMenu.Item>最新文章 RSS 订阅</DropdownMenu.Item></Link>
                            </DropdownMenu.Content>
                        </DropdownMenu.Root>

                        <Separator orientation="vertical" />

                        <DropdownMenu.Root>
                            <DropdownMenu.Trigger>
                                <IconButton variant="soft">
                                    <Tooltip content="本站代码 GitHub 开源">
                                        <Github width="14" height="14" />
                                    </Tooltip>
                                </IconButton>
                            </DropdownMenu.Trigger>
                            <DropdownMenu.Content>
                                <Link size="1" target="_blank" href="https://github.com/leileiluoluo/boyouquan-ui"><DropdownMenu.Item>前端代码 GitHub</DropdownMenu.Item></Link>
                                <DropdownMenu.Separator />
                                <Link size="1" target="_blank" href="https://github.com/leileiluoluo/boyouquan-api"><DropdownMenu.Item>后端代码 GitHub</DropdownMenu.Item></Link>
                            </DropdownMenu.Content>
                        </DropdownMenu.Root>

                        <Separator orientation="vertical" />

                        <Link target="_blank" href="https://curl.qcloud.com/okTsvSrj">
                            <IconButton variant="soft">
                                <Tooltip content="本站使用的云服务">
                                    <Cloud width="14" height="14" />
                                </Tooltip>
                            </IconButton>
                        </Link>
                    </Flex>
                    */}
                </Box>
                <Box mt="2">
                    <Box align="center" mt="2">
                        <Link href="/planet-shuttle" target="_blank">
                            <img height="24px" src="https://bokehub.com/assets/images/sites/logo/planet-shuttle.svg"></img>
                        </Link>
                    </Box>
                    <Box mb="2" align="center">
                        <Text size="1" style={{ fontSize: '13px', fontWeight: 500 }}>每一个博客世界，都值得被探寻；每一个优质声音，都不应该被湮灭。</Text>
                    </Box>
                    <Box mb="2" align="center">
                        <Text size="1" style={{ fontSize: '12px', opacity: 0.6, color: 'gray', fontWeight: 400 }}>本站使用博友圈（www.boyouquan.com）开源程序创建</Text>
                    </Box>
                    <Flex gap="2" direction="column" align="center">
                        <Link size="1" href="https://beian.miit.gov.cn/"></Link>
                        <Text size="1" style={{ fontSize: '12px', fontWeight: 500 }}>Copyright © 2025 <Link href="https://bokehub.com/home">博客中心</Link></Text>
                    </Flex>
                </Box>
            </Box>
        </Container>
    )
}